<template>
  <div class="col-12 p-0 bg-secondary d-flex overflow-x">
    <div
      class="text-dark bg-white resume__card animate__animated  animate__fadeInRight"
      :style="resume.length > 0 ? 'display: block' : 'display: none'"
      v-for="(resume, r) in resumes"
      :key="r"
    >
      <ul>
        <li v-for="(list, i) in resume" :key="i">{{ list }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import tag from "../tools/tag.svg";
export default {
  name: "ResumeBar",
  props: {
    resumes: Object,
  },
  data() {
    return {
      tag,
    };
  },
};
</script>
<style lang="scss">
/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.overflow-x {
  overflow-x: scroll;
}
.resume__card {
  position: relative;
  border-radius: 5px;
  margin-right: 18px;
  min-width: 150px;

  // &::after {
  //   content: "";
  //   position: absolute;
  //   top: calc(50% - 30px);
  //   left: calc(100% - 2px);

  //   display: inline-block;
  //   width: 0;
  //   height: 0;
  //   border-style: solid;
  //   border-width: 30px 0 30px 16.6px;
  //   border-color: transparent transparent transparent white;
  // }

  .tag {
    position: absolute;
    left: 0;
    top: -3px;
    // height: calc(100% + 10px);
    min-width: 100%;
    height: 100%;
  }

  ul {
    padding: 2px 5px 0 5px;
    list-style: none;
    position: relative;
    z-index: 2;

    li {
      padding: 0;
      font-size: 12px;
    }
  }
}
</style>
